export default {
  init() {
    // Remove empty paragraphs
    $('main p').each(function () {
      if ($(this).children().length === 0 && $(this).text().trim() === '') {
        $(this).remove();
      }
    });
  },
};
